import $ from "jquery";
(function($) {
	$.fn.dropdown = function(opts) {
		// default configuration
		var config = $.extend({}, { 
            fadeInTime: 1000,
            fadeOutTime: 600,
            interval: 5600
        }, opts);
		// main function
		function init(obj) {
            var dNewsticker = obj;
            var dFrame = dNewsticker.find('.js-frame');
            var dItem = dFrame.find('.js-item');
            var dCurrent;
            var stop = false;
            var fStop = false;
            var next;

            dItem.hide();
            dItem.eq(0).addClass('current');
            dItem.eq(0).show();

            var move = setInterval(function(){
                if(!stop && !fStop){
                    dCurrent = dFrame.find('.current');
                    dCurrent.fadeOut(config.fadeOutTime, function(){
                        if(dCurrent.next().length !== 0){
                            dCurrent.removeClass('current');
                            dCurrent.next().addClass('current');
                            dCurrent.next().fadeIn(config.fadeInTime);
                        } else {
                            dCurrent.removeClass('current');
                            dItem.eq(0).addClass('current');
                            dItem.eq(0).fadeIn(config.fadeInTime);
                        }
                    });
                }
            }, config.interval);
            dNewsticker.on('mouseover mouseout', function(e){
                if(e.type == 'mouseover'){
                    stop = true;
                } else{
                    stop = false;
                }
            });

            dNewsticker.find('.ticker-container').on('mouseover mouseout', function(e){
                if(e.type == 'mouseover'){
                    $('#play-pause').addClass('paused');
                } else{
                    if (!fStop) {
                        $('#play-pause').removeClass('paused');
                    }
                }
            });
            
            dNewsticker.on('click', function(e){
                if (e.target.id == 'next' || e.target.id == 'prev') {
                    clearInterval(move);
                    clearInterval(next);
                    dCurrent = dFrame.find('.current');

                    if (e.target.id == 'next') {
                        if(dCurrent.next().length !== 0){
                            dCurrent.hide();
                            dCurrent.removeClass('current');
                            dCurrent.next().addClass('current');
                            dCurrent.next().show();
                        } else {
                            dCurrent.hide();
                            dCurrent.removeClass('current');
                            dItem.eq(0).addClass('current');
                            dItem.eq(0).show();
                        }
                    } else {
                        if(dCurrent.prev().length !== 0 && dCurrent.prev().text() != "LATEST:"){
                            dCurrent.hide();
                            dCurrent.removeClass('current');
                            dCurrent.prev().addClass('current');
                            dCurrent.prev().show();
                        } else {
                            dCurrent.hide();
                            dCurrent.removeClass('current');
                            dItem.eq(dItem.length-1).addClass('current');
                            dItem.eq(dItem.length-1).show();
                        }
    
                    }

                    next = setInterval(function(){
                        if(!stop && !fStop){
                            dCurrent = dFrame.find('.current');
                            dCurrent.fadeOut(config.fadeOutTime, function(){
                                if(dCurrent.next().length !== 0){
                                    dCurrent.removeClass('current');
                                    dCurrent.next().addClass('current');
                                    dCurrent.next().fadeIn(config.fadeInTime);
                                } else {
                                    dCurrent.removeClass('current');
                                    dItem.eq(0).addClass('current');
                                    dItem.eq(0).fadeIn(config.fadeInTime);
                                }
                            });
                        }
                    }, config.interval);

                    fStop = true;
                    stop = true;
                    $('#play-pause').addClass('paused');
                }

                if (e.target.id == 'play-pause') {
                    fStop = !fStop;
                    fStop ? $(e.target).addClass('paused') : $(e.target).removeClass('paused');
                }
            });

        }

		// initialize every element
		this.each(function() {
			init($(this));
		});

		return this;
	};
})($);